/* QA-only compatibility experiment for the native photo editor. No style/geometry edits. */
(() => {
  'use strict';
  const globals = new Set(Array.from({ length: 49 }, (_, i) => i + 4242));
  let pendingPhotoHeading = '';
  function rememberPhoto(event) {
    const field = event.target.closest?.('.tee-field--photo');
    if (!field) return;
    pendingPhotoHeading = field.querySelector('.tee-field__heading span')?.textContent.trim() || '';
  }
  document.addEventListener('click', rememberPhoto, true);
  document.addEventListener('change', rememberPhoto, true);
  function recoverDeferredSelection(editor) {
    if (editor.npSelectionRecovery) return;
    editor.npSelectionRecovery = true;
    const prepare = editor.prepareDraggable;
    function retry() {
      if (editor.fieldId || !pendingPhotoHeading || !editor.$el?.isConnected) return;
      for (const board of editor.boards) {
        const layer = editor.flattenLayers(board.layers || []).find(layer => layer.editor === 'ImagePlacement' &&
          globals.has(Number(layer.raw?.global_option)) &&
          (layer.raw.name === pendingPhotoHeading || layer.raw.form_label === pendingPhotoHeading));
        if (layer) {
          const key = 'global-option-' + layer.raw.global_option;
          const values = editor.readCustomization || editor.localValue;
          if (!(values[key + '-position']?.w > 0) && !(values[layer.id + '-position']?.w > 0)) {
            const field = Array.from(document.querySelectorAll('.tee-field--photo')).find(field => field.querySelector('.tee-field__heading span')?.textContent.trim() === pendingPhotoHeading);
            const image = field?.querySelector('.tee-photo-image');
            if (image && !image.complete) image.addEventListener('load', retry, { once:true });
            if (image?.complete && image.naturalWidth > 0 && image.naturalHeight > 0) {
              const ratio = image.naturalWidth / image.naturalHeight;
              const w = Math.min(1, ratio), h = Math.min(1, 1 / ratio);
              editor.localValue = { ...editor.localValue, [key + '-position']: { x:(1-w)/2, y:(1-h)/2, w, h, ratio, a:0 } };
              editor.$nextTick(retry);
              return;
            }
          }
          prepare.call(editor, { fieldId:layer.id, layerId:layer.id, fieldName:'global-option-'+layer.raw.global_option });
          if (editor.fieldId) return;
        }
      }
    }
    editor.$watch(() => [editor.readCustomization, editor.modelValue, editor.boards], retry, { flush:'post' });
    editor.$nextTick(retry);
  }
  let attempts = 0;
  function install() {
    const app = window.TEEINBLUE_APP;
    const dialog = app && typeof app.component === 'function' && app.component('ImagePlacementDialog');
    const editor = dialog && dialog.components && dialog.components.ImagePlacement;
    if (!editor || !editor.computed || !editor.methods) {
      if (++attempts < 160) setTimeout(install, 250);
      return;
    }
    if (editor.npPhotoAnchorQA) return;
    editor.npPhotoAnchorQA = true;
    const originalPlacement = editor.computed.placement;
    editor.computed.placement = {
      get() {
        const current = originalPlacement.get.call(this);
        const key = this.placementFieldId || '';
        const id = Number(key.replace('global-option-', ''));
        if (!key.startsWith('global-option-') || !globals.has(id) || current.w > 0 && current.h > 0) return current;
        const values = this.readCustomization || this.localValue;
        return values[this.fieldId + '-position'] || current;
      },
      set(value) { originalPlacement.set.call(this, value); }
    };
    const originalField = editor.computed.currentField;
    editor.computed.currentField = function () {
      recoverDeferredSelection(this);
      const current = originalField.call(this);
      if (current) return current;
      const key = this.placementFieldId || '';
      const id = Number(key.replace('global-option-', ''));
      if (!key.startsWith('global-option-') || !globals.has(id)) return current;
      for (const board of this.boards) {
        const layer = this.flattenLayers(board.layers || []).find(layer => layer.editor === 'ImagePlacement' && Number(layer.raw && layer.raw.global_option) === id);
        if (layer) return { id: layer.id, boardId: board.id };
      }
      return current;
    };
    const originalActive = editor.computed.activeLayer;
    editor.computed.activeLayer = function () {
      const current = originalActive.call(this);
      const key = this.placementFieldId || '';
      const id = Number(key.replace('global-option-', ''));
      if (!key.startsWith('global-option-') || !globals.has(id)) return current;
      const candidates = this.currentBoardLayers.filter(layer => layer.editor === 'ImagePlacement' && Number(layer.raw && layer.raw.global_option) === id);
      const selected = current || candidates[0] || null;
      return selected;
    };
    document.documentElement.dataset.npPhotoAnchorInstalled = 'true';
  }
  install();
})();
